import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";
import _kebabCase from "lodash/kebabCase";
import _isEmpty from "lodash/isEmpty";
import _isUndefined from "lodash/isUndefined";

var _DRIVER_GROUP_CONFIG;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import classes from '@nerdwallet/base-styles/classes'; // @todo: port into nwjs-marketplace

import { getMarketingBullets, getTermsAndFeesLink } from '@nerdwallet/cc-utils/lib/offer-api/selectors';
import { getSlug, isActive } from '@nerdwallet/marketplace/selectors/common';
import { getPrequalLink, getPrequalLinkText, getBalanceTransferIntroTime, getBalanceTransferIntroApr, getImageDimensions, getMatchScore } from '@nerdwallet/marketplace/selectors/credit-cards';
import { isNonMonetizing } from '@nerdwallet/marketplace/utils';
import { Button, Li, Link, List, Type } from '@nerdwallet/currency';
import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import { getBucketFromScore, BucketName } from '@nerdwallet/nw-client-lib/credit-score';
import { getCreditScore } from '@nerdwallet/js-auth-tools/dist/selectors/credit-score';
import { isSignedIn } from '@nerdwallet/js-auth-tools/dist/selectors';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES, APPLY_NOW_FINISH_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import { DEFAULT_DRIVER_GROUP, getDrivers, getImageData, getMonetizable, sanitizeNode } from '../lib/utils';
import LikelihoodOfApprovalCTA from '../likelihood-of-approval-cta';
import styles from '../marketplace-product-card.module.less';
import { TRK_PRODUCT_LOCATION } from '../lib/constants';
var KETO_CARD_BREAKPOINT = 999; // @imageWrapperBreakpointMax

var MPC_BREAKPOINT = 766; // @screen-medium

var MPC_IMAGE_MOBILE_WIDTH = 160; // @imageWidthMobile

var MAX_IMAGE_WIDTH_DESKTOP = 221; // @imageWidthDesktop

var MAX_IMAGE_HEIGHT = 140; // @imageMaxHeight

var KETO_IMAGE_MOBILE_WIDTH = 140; // @imageWidthMobile

var WIDTH = 'width';
var HEIGHT = 'height';
/**
 * Export all the keys of overridable driverGroups
 */

export var DRIVER_GROUPS_CREDIT_CARDS = {
  CC_BALANCE_TRANSFER: 'CC_BALANCE_TRANSFER',
  CC_BUILD_CREDIT: 'CC_BUILD_CREDIT',
  CC_CLASSIC_DEFAULT: 'CC_CLASSIC_DEFAULT',
  CC_REWARDS: 'CC_REWARDS',
  CC_BALANCE_TRANSFER_LOA: 'CC_BALANCE_TRANSFER_LOA',
  CC_BALANCE_TRANSFER_ROUNDUP: 'CC_BALANCE_TRANSFER_ROUNDUP',
  // Specific to SHOP-11146
  CC_BT_AND_REWARDS: 'CC_BT_AND_REWARDS',
  CC_BT_ROUNDUP_AND_REWARDS: 'CC_BT_ROUNDUP_AND_REWARDS',
  // Specific to SHOP-11741
  CC_REWARDS_11741_VARIANT: 'CC_REWARDS_11741_VARIANT',
  // Specific to SHOP-11606
  CC_BONUS_OFFER_11606_VARIANT: 'CC_BONUS_OFFER_11606_VARIANT'
};
/**
 * @param {Object} args -
 * @param {Object} args.identity -
 * @param {Object} args.marketplaceEntity -
 * @param {string} args.trkProductPosition -
 * @returns {Object} - Quick fact object for LOA.
 */

var getQuickFactLikelihoodOfApproval = function getQuickFactLikelihoodOfApproval(args) {
  var _args$analytics;

  var quickFactLikelihoodOfApprovalOptions = {
    ctaComponent: /*#__PURE__*/React.createElement(LikelihoodOfApprovalCTA, {
      analytics: (_args$analytics = args.analytics) === null || _args$analytics === void 0 ? void 0 : _args$analytics.loaCtaProps,
      ctaText: "Get your free credit score",
      enableAnalytics: args.enableAnalytics
    }),
    identity: args.identity,
    trackingProps: {
      impressionKey: getSlug(args.marketplaceEntity),
      sectionCategory: 'product-card-approval-odds',
      // Element Interactions do not support productPosition, so use sectionPosition
      sectionPosition: args.trkProductPosition
    }
  };
  var quickFactsLikelihoodOfApproval;

  if (args.showMatchScoreCTA) {
    quickFactsLikelihoodOfApproval = quickFactMappings.creditCards.getQuickFactRecommendedCreditScoreRange(args.marketplaceEntity);
  } else if (args.isKetoCard) {
    var _args$analytics2;

    quickFactsLikelihoodOfApproval = quickFactMappings.creditCards.getQuickFactLikelihoodOfApprovalText(args.marketplaceEntity, _objectSpread(_objectSpread({}, quickFactLikelihoodOfApprovalOptions), {}, {
      ctaComponent: /*#__PURE__*/React.createElement(LikelihoodOfApprovalCTA, {
        analytics: (_args$analytics2 = args.analytics) === null || _args$analytics2 === void 0 ? void 0 : _args$analytics2.loaCtaProps,
        ctaText: "Get your free credit score",
        enableAnalytics: args.enableAnalytics,
        isKetoCard: true
      })
    }));
  } else {
    quickFactsLikelihoodOfApproval = quickFactMappings.creditCards.getQuickFactLikelihoodOfApproval(args.marketplaceEntity, quickFactLikelihoodOfApprovalOptions);
  }

  return quickFactsLikelihoodOfApproval;
};
/**
 * @param {Object} args -
 * @param {Object} args.identity -
 * @param {Object} args.marketplaceEntity -
 * @param {string} args.trkProductPosition -
 * @returns {Object[]} - list of quick-fact objects.
 */


var getClassicDefaultDrivers = function getClassicDefaultDrivers(args) {
  var _args$analytics3, _args$impressionConte;

  return [quickFactMappings.creditCards.getQuickFactAnnualFee(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(args.marketplaceEntity, false, false, _objectSpread(_objectSpread({}, args === null || args === void 0 ? void 0 : (_args$analytics3 = args.analytics) === null || _args$analytics3 === void 0 ? void 0 : _args$analytics3.productImpressionProps), {}, {
    productImpressionId: args === null || args === void 0 ? void 0 : (_args$impressionConte = args.impressionContext) === null || _args$impressionConte === void 0 ? void 0 : _args$impressionConte.impressionId
  })), quickFactMappings.creditCards.getQuickFactIntroApr(args.marketplaceEntity), getQuickFactLikelihoodOfApproval(args)];
};

var getRewardsDrivers = function getRewardsDrivers(args) {
  var qfMappings = quickFactMappings.creditCards;
  return [qfMappings.getQuickFactAnnualFee(args.marketplaceEntity), qfMappings.getQuickFactRewardRate(args.marketplaceEntity), qfMappings.getQuickFactIntroOffer(args.marketplaceEntity), getQuickFactLikelihoodOfApproval(args)];
};
/**
 * Get drivers for CC_REWARDS_11741_VARIANT driver group for the following
 * 3 card categories: REWARDS, TRAVEL, CASHBACK
 * https://nerdwallet.atlassian.net/browse/SHOP-11741
 */


var getRewards11741VariantDrivers = function getRewards11741VariantDrivers(args) {
  // Show the 5th and 6th driver only if the cards qualify under
  // zero-percent apr or have balance transfer offering
  // If BalanceTransferIntroApr is defined and BalanceTransferIntroTime is greater than 0
  var hasBalanceTransferOffer = !_isUndefined(getBalanceTransferIntroApr(args.marketplaceEntity)) && getBalanceTransferIntroTime(args.marketplaceEntity) > 0;

  if (hasBalanceTransferOffer) {
    var _args$analytics4, _args$impressionConte2;

    return [].concat(_toConsumableArray(getRewardsDrivers(args)), [quickFactMappings.creditCards.getQuickFactIntroApr(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(args.marketplaceEntity, false, false, _objectSpread(_objectSpread({}, args === null || args === void 0 ? void 0 : (_args$analytics4 = args.analytics) === null || _args$analytics4 === void 0 ? void 0 : _args$analytics4.productImpressionProps), {}, {
      productImpressionId: args === null || args === void 0 ? void 0 : (_args$impressionConte2 = args.impressionContext) === null || _args$impressionConte2 === void 0 ? void 0 : _args$impressionConte2.impressionId
    }))]);
  }

  return getRewardsDrivers(args);
};

var getBuildCreditDrivers = function getBuildCreditDrivers(_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      analytics = _ref.analytics,
      impressionContext = _ref.impressionContext;
  return [quickFactMappings.creditCards.getQuickFactAnnualFee(marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(marketplaceEntity, false, false, _objectSpread(_objectSpread({}, analytics === null || analytics === void 0 ? void 0 : analytics.productImpressionProps), {}, {
    productImpressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId
  })), quickFactMappings.creditCards.getQuickFactIntroApr(marketplaceEntity), quickFactMappings.creditCards.getQuickFactMinimumDepositDescription(marketplaceEntity)];
};

var getBalanceTransferWithLOADrivers = function getBalanceTransferWithLOADrivers(args) {
  var _args$analytics5, _args$impressionConte3;

  return [quickFactMappings.creditCards.getQuickFactBalanceTransferFeeDescription(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactIntroApr(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(args.marketplaceEntity, false, false, _objectSpread(_objectSpread({}, (_args$analytics5 = args.analytics) === null || _args$analytics5 === void 0 ? void 0 : _args$analytics5.productImpressionProps), {}, {
    productImpressionId: args === null || args === void 0 ? void 0 : (_args$impressionConte3 = args.impressionContext) === null || _args$impressionConte3 === void 0 ? void 0 : _args$impressionConte3.impressionId
  })), getQuickFactLikelihoodOfApproval(args)];
};
/**
 * Get drivers for CC_BALANCE_TRANSFER driver group
 */


var getBalanceTransferDrivers = function getBalanceTransferDrivers(_ref2) {
  var marketplaceEntity = _ref2.marketplaceEntity,
      analytics = _ref2.analytics,
      impressionContext = _ref2.impressionContext;
  return [quickFactMappings.creditCards.getQuickFactAnnualFee(marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(marketplaceEntity, false, false, _objectSpread(_objectSpread({}, analytics === null || analytics === void 0 ? void 0 : analytics.productImpressionProps), {}, {
    productImpressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId
  })), quickFactMappings.creditCards.getQuickFactIntroApr(marketplaceEntity), quickFactMappings.creditCards.getQuickFactBalanceTransferFeeDescription(marketplaceEntity)];
};
/**
 * Get drivers for CC_BALANCE_TRANSFER_ROUNDUP driver group
 */


var getBalanceTransferRoundupDrivers = function getBalanceTransferRoundupDrivers(args) {
  var _args$analytics6, _args$impressionConte4;

  return [quickFactMappings.creditCards.getQuickFactAnnualFee(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactIntroApr(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactRegularApr(args.marketplaceEntity, false, false, _objectSpread(_objectSpread({}, args === null || args === void 0 ? void 0 : (_args$analytics6 = args.analytics) === null || _args$analytics6 === void 0 ? void 0 : _args$analytics6.productImpressionProps), {}, {
    productImpressionId: args === null || args === void 0 ? void 0 : (_args$impressionConte4 = args.impressionContext) === null || _args$impressionConte4 === void 0 ? void 0 : _args$impressionConte4.impressionId
  })), getQuickFactLikelihoodOfApproval(args)];
};
/**
 * Groups Rewards Rate and Intro Offer driver together
 */


var getRewardRateAndIntroDriver = function getRewardRateAndIntroDriver(marketplaceEntity) {
  return [quickFactMappings.creditCards.getQuickFactRewardRate(marketplaceEntity), quickFactMappings.creditCards.getQuickFactIntroOffer(marketplaceEntity)];
};
/**
 * Get drivers for CC_BT_AND_REWARDS driver group
 * https://nerdwallet.atlassian.net/browse/SHOP-11146
 */


var getBTRoundupAndRewardsDrivers = function getBTRoundupAndRewardsDrivers(args) {
  return [].concat(_toConsumableArray(getBalanceTransferRoundupDrivers(args)), _toConsumableArray(getRewardRateAndIntroDriver(args.marketplaceEntity)));
};
/**
 * Get drivers for CC_BT_ROUNDUP_AND_REWARDS driver group
 * https://nerdwallet.atlassian.net/browse/SHOP-11146
 */


var getBTAndRewardsDrivers = function getBTAndRewardsDrivers(args) {
  return [].concat(_toConsumableArray(getBalanceTransferDrivers(args)), _toConsumableArray(getRewardRateAndIntroDriver(args.marketplaceEntity)));
};
/**
 * @enum {string}
 */


var RewardType = {
  CASH: 'Cash',
  MILES: 'Miles',
  POINTS: 'Points'
};
/**
 * Get drivers for CC_BONUS_OFFER_11606_VARIANT driver group
 * https://nerdwallet.atlassian.net/browse/SHOP-11606
 */

var getBonusValueVariantDrivers = function getBonusValueVariantDrivers(args) {
  var introOffer = quickFactMappings.creditCards.getQuickFactIntroOffer(args.marketplaceEntity);
  return introOffer.description === RewardType.CASH ? getRewardsDrivers(args) : [quickFactMappings.creditCards.getQuickFactAnnualFee(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactRewardRate(args.marketplaceEntity), quickFactMappings.creditCards.getQuickFactEstBonusValue(args.marketplaceEntity), getQuickFactLikelihoodOfApproval(args)];
};
/**
 * Define config of how to create drivers based off a driverGroup and other props
 */


var DRIVER_GROUP_CONFIG = (_DRIVER_GROUP_CONFIG = {}, _defineProperty(_DRIVER_GROUP_CONFIG, DEFAULT_DRIVER_GROUP, getRewardsDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_CLASSIC_DEFAULT, getClassicDefaultDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BALANCE_TRANSFER, getBalanceTransferDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BUILD_CREDIT, getBuildCreditDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_REWARDS, getRewardsDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BALANCE_TRANSFER_LOA, getBalanceTransferWithLOADrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BALANCE_TRANSFER_ROUNDUP, getBalanceTransferRoundupDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BT_AND_REWARDS, getBTAndRewardsDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BT_ROUNDUP_AND_REWARDS, getBTRoundupAndRewardsDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_REWARDS_11741_VARIANT, getRewards11741VariantDrivers), _defineProperty(_DRIVER_GROUP_CONFIG, DRIVER_GROUPS_CREDIT_CARDS.CC_BONUS_OFFER_11606_VARIANT, getBonusValueVariantDrivers), _DRIVER_GROUP_CONFIG);

var isSignedInAndCreditScoreExcellent = function isSignedInAndCreditScoreExcellent(identity) {
  // if the user is logged in
  if (isSignedIn(identity)) {
    // get the credit score to determine the credit bucket
    var creditScore = getCreditScore(identity); // If the user has a credit score and the credit score bucket
    // is "excellent", ONLY then display PRE-QUAL CTA for the user else hide it

    return creditScore && getBucketFromScore(creditScore) === BucketName.excellent;
  }

  return false;
};
/**
 * Given a dimensions object with a height and width, return the resized dimensions object.
 *
 * @param {Object} dimensions
 * @param {string} fixedDimension
 * @param {number} fixedValue
 * @returns {Object} - {height, width}
 */


var resizeImageGivenOneDimension = function resizeImageGivenOneDimension(dimensions, fixedDimension, fixedValue) {
  var ratio = dimensions.width / dimensions.height;

  switch (fixedDimension) {
    case WIDTH:
      return {
        height: Math.round(fixedValue / ratio),
        width: fixedValue
      };

    case HEIGHT:
      return {
        height: fixedValue,
        width: Math.round(fixedValue * ratio)
      };

    default:
      return dimensions;
  }
};
/**
 * @typedef {Object} MarketplaceEntityImageData
 * @property {string} src
 * @property {string} alt
 * @property {number} breakpoint
 * @property {Object} imageDimensions - { height: number, width: number}
 * @property {Object} imageDimensionsMobile - { height: number, width: number}
 * @property {string} sizes
 * @property {string} srcSet
 */

/**
 * Wrapper around getImageData which augments image data with lazy load information.
 * @param {MarketplaceEntityImageData} marketplaceEntity
 * @param {boolean} isKetoCard
 * @returns {MarketplaceEntityImageData}
 */


var getLazyLoadableImageData = function getLazyLoadableImageData(marketplaceEntity, isKetoCard) {
  var imageData = getImageData(marketplaceEntity, 'large');
  var imageDataMobile = getImageData(marketplaceEntity, 'medium');
  var imageDimensions = getImageDimensions(marketplaceEntity, 'large');
  var imageDimensionsMobile = getImageDimensions(marketplaceEntity, 'medium');

  if (_isEmpty(imageDimensions) || _isEmpty(imageDimensionsMobile) || !isActive(marketplaceEntity)) {
    // if conditions for lazy loading are not met, load image normally
    return imageData;
  }

  var breakpoint = KETO_CARD_BREAKPOINT;
  var mobileWidth = KETO_IMAGE_MOBILE_WIDTH;

  if (!isKetoCard) {
    // keto card's mobile image matches the standard medium card image size of 140px
    // mpc uses a width of 160px, so we need to use the ratio to calculate it's height
    imageDimensionsMobile = resizeImageGivenOneDimension(imageDimensionsMobile, WIDTH, MPC_IMAGE_MOBILE_WIDTH);
    breakpoint = MPC_BREAKPOINT;
    mobileWidth = MPC_IMAGE_MOBILE_WIDTH;
  } // when the image's height is larger than our max image height, need to calculate the relative width


  if (imageDimensions.height > MAX_IMAGE_HEIGHT) {
    imageDimensions = resizeImageGivenOneDimension(imageDimensions, HEIGHT, MAX_IMAGE_HEIGHT);
  }

  if (imageDimensionsMobile.height > MAX_IMAGE_HEIGHT) {
    imageDimensionsMobile = resizeImageGivenOneDimension(imageDimensionsMobile, HEIGHT, MAX_IMAGE_HEIGHT);
  }

  var srcSet = '';
  var sizes = '';

  if (imageDimensions.width && imageDimensionsMobile.width) {
    srcSet = "".concat(imageData.src, " ").concat(imageDimensions.width, "w, ").concat(imageDataMobile.src, " ").concat(imageDimensionsMobile.width, "w");
    sizes = "(max-width: ".concat(breakpoint, "px) ").concat(mobileWidth, "px, ").concat(MAX_IMAGE_WIDTH_DESKTOP, "px");
  }

  return _objectSpread(_objectSpread({}, imageData), {}, {
    breakpoint: breakpoint,
    imageDimensions: imageDimensions,
    imageDimensionsMobile: imageDimensionsMobile,
    sizes: sizes,
    srcSet: srcSet
  });
};

export default (function (_ref3) {
  var _analytics$productImp, _analytics$productImp2, _analytics$productImp3, _analytics$productImp4, _analytics$productImp5, _analytics$productImp6, _analytics$productImp7, _analytics$productImp8;

  var analytics = _ref3.analytics,
      driverGroup = _ref3.driverGroup,
      enableAnalytics = _ref3.enableAnalytics,
      hidePrequalCta = _ref3.hidePrequalCta,
      identity = _ref3.identity,
      isKetoCard = _ref3.isKetoCard,
      marketplaceEntity = _ref3.marketplaceEntity,
      omitRating = _ref3.omitRating,
      productType = _ref3.productType,
      reviewLinkHref = _ref3.reviewLinkHref,
      shouldLogImpression = _ref3.shouldLogImpression,
      showMatchScoreCTA = _ref3.showMatchScoreCTA,
      showNotYetRated = _ref3.showNotYetRated,
      starRating = _ref3.starRating,
      taxonomy = _ref3.taxonomy,
      trkPageType = _ref3.trkPageType,
      trkProductPosition = _ref3.trkProductPosition;
  var marketingBullets = getMarketingBullets(marketplaceEntity);
  var termsFeesAndLink = getTermsAndFeesLink(marketplaceEntity);
  var isNonMonetizingOffer = isNonMonetizing(marketplaceEntity);
  var prequalLink = getPrequalLink(marketplaceEntity);
  var prequalLinkText = getPrequalLinkText(marketplaceEntity);
  var impressionContext = useContext(ImpressionContext); // if the hidePrequalCta test is active,
  // check if the identity exists(i.e user has logged in) and the credit score bucket to
  // to either display/hide the prequal Link

  var shouldShowPrequalLink = hidePrequalCta ? identity && isSignedInAndCreditScoreExcellent(identity) : true;
  var secondaryCtaProps = {};

  if (!isNonMonetizingOffer) {
    secondaryCtaProps.secondaryCtaText = 'Rates & Fees';
    secondaryCtaProps.secondaryCtaHref = termsFeesAndLink;
  }

  var PREQUAL_CTA_TRK = (analytics === null || analytics === void 0 ? void 0 : analytics.prequalCTATrk) || 'cc_product_card';
  var prequalLinkWithTrk = "".concat(prequalLink, "/?trk=nw_cc-best_prequal&navigation_source_tracking_code=").concat(PREQUAL_CTA_TRK);
  var mobileGetPrequal = isKetoCard ? /*#__PURE__*/React.createElement(Button, {
    href: prequalLinkWithTrk
  }, "Get Pre-Qualified") : /*#__PURE__*/React.createElement(Link, {
    href: prequalLinkWithTrk
  }, "Get Pre-Qualified");
  var drivers = getDrivers({
    analytics: analytics,
    driverGroupConfig: DRIVER_GROUP_CONFIG,
    driverGroup: driverGroup,
    enableAnalytics: enableAnalytics,
    identity: identity,
    isKetoCard: isKetoCard,
    marketplaceEntity: marketplaceEntity,
    showMatchScoreCTA: showMatchScoreCTA,
    trkProductPosition: trkProductPosition,
    impressionContext: impressionContext
  });
  var matchScore = getMatchScore(marketplaceEntity);

  if (!omitRating && matchScore && isKetoCard && showMatchScoreCTA) {
    var args = {
      analytics: analytics,
      enableAnalytics: enableAnalytics || !_isEmpty(analytics),
      trkLocation: TRK_PRODUCT_LOCATION,
      trkPageType: trkPageType
    };
    var starRatingQuickFact;

    if (showNotYetRated) {
      starRatingQuickFact = quickFactMappings.creditCards.getQuickFactStarRating({}, _objectSpread(_objectSpread({}, args), {}, {
        showNotYetRated: showNotYetRated
      }));
    } else {
      starRatingQuickFact = quickFactMappings.creditCards.getQuickFactStarRating(marketplaceEntity, _objectSpread(_objectSpread({}, args), {}, {
        productType: productType,
        starRating: starRating,
        ratingTextHref: reviewLinkHref,
        trkTaxonomy: taxonomy
      }));
    }

    drivers = [starRatingQuickFact].concat(_toConsumableArray(drivers));
  }

  return _objectSpread({
    drivers: drivers,
    productDetails: !_isEmpty(marketingBullets) ? /*#__PURE__*/React.createElement(List, null, marketingBullets.map(function (productDetail) {
      return /*#__PURE__*/React.createElement(Li, {
        key: "product-detail-".concat(_kebabCase(productDetail)),
        className: classes('margin-bottom-2')
      }, sanitizeNode(productDetail, true));
    }), !isNonMonetizingOffer && termsFeesAndLink !== null && !isKetoCard ? /*#__PURE__*/React.createElement(Li, null, /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
      className: styles.secondaryCtaProductDetails,
      finishType: APPLY_NOW_FINISH_TYPES.EXTERNAL_CONTENT,
      id: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
      link: termsFeesAndLink,
      linkType: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      monetizable: getMonetizable(marketplaceEntity),
      marketplaceEntity: marketplaceEntity,
      sectionName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp = analytics.productImpressionProps) === null || _analytics$productImp === void 0 ? void 0 : (_analytics$productImp2 = _analytics$productImp.payload) === null || _analytics$productImp2 === void 0 ? void 0 : _analytics$productImp2.section_name) || "marketplace_product_card",
      sectionPosition: analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp3 = analytics.productImpressionProps) === null || _analytics$productImp3 === void 0 ? void 0 : (_analytics$productImp4 = _analytics$productImp3.payload) === null || _analytics$productImp4 === void 0 ? void 0 : _analytics$productImp4.section_position,
      type: LINK_TYPES.LINK,
      shouldLogImpression: shouldLogImpression
    }, "View Rates and Fees")) : null, !isNonMonetizingOffer && termsFeesAndLink !== null && isKetoCard ? /*#__PURE__*/React.createElement(Li, null, /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
      className: styles.secondaryCta,
      finishType: APPLY_NOW_FINISH_TYPES.EXTERNAL_CONTENT,
      id: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
      link: termsFeesAndLink,
      linkType: APPLY_NOW_LINK_TYPES.ratesAndFeesText,
      monetizable: getMonetizable(marketplaceEntity),
      marketplaceEntity: marketplaceEntity,
      sectionName: (analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp5 = analytics.productImpressionProps) === null || _analytics$productImp5 === void 0 ? void 0 : (_analytics$productImp6 = _analytics$productImp5.payload) === null || _analytics$productImp6 === void 0 ? void 0 : _analytics$productImp6.section_name) || "marketplace_product_card",
      sectionPosition: analytics === null || analytics === void 0 ? void 0 : (_analytics$productImp7 = analytics.productImpressionProps) === null || _analytics$productImp7 === void 0 ? void 0 : (_analytics$productImp8 = _analytics$productImp7.payload) === null || _analytics$productImp8 === void 0 ? void 0 : _analytics$productImp8.section_position,
      type: LINK_TYPES.LINK,
      shouldLogImpression: shouldLogImpression
    }, "View Rates and Fees")) : null, shouldShowPrequalLink && prequalLink && prequalLinkText && /*#__PURE__*/React.createElement(Li, {
      key: "product-detail-prequal-link",
      className: classes('margin-bottom-2')
    }, /*#__PURE__*/React.createElement(Type, {
      className: classes('margin-bottom-2')
    }, prequalLinkText), /*#__PURE__*/React.createElement("div", {
      className: styles['prequalCta--wide']
    }, /*#__PURE__*/React.createElement(Button, {
      href: prequalLinkWithTrk
    }, "Get Pre-Qualified")), /*#__PURE__*/React.createElement("div", {
      className: styles['prequalCta--mobile']
    }, mobileGetPrequal))) : null,
    imageData: getLazyLoadableImageData(marketplaceEntity, isKetoCard),
    reviewLinkTabIndex: -1
  }, secondaryCtaProps);
});